import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Table } from "antd";
import { debounce } from "lodash";

import Modals from "../../common/modal";

const { Column } = Table;

const ImportReportSupplier = ({
  openModal,
  setOpenModal,
  errorData,
  successData,
}) => {
  const combinedData = [...errorData, ...successData];
  const errorCount = Array.isArray(errorData) ? errorData.length : 0;
  const successCount = Array.isArray(successData) ? successData.length : 0;

  const [isSuccess, setIsSuccess] = useState(true);
  const [isFailed, setIsFailed] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef();

  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 100);
    };

    fetchData();
  }, [currentPage]);

  const handleScroll = debounce(() => {
    const tableEl = tableRef.current;

    const threshold = 100; 
    const percentageThreshold = 0.8;
    const isNearBottom =
      tableEl.scrollTop + tableEl.clientHeight >=
        tableEl.scrollHeight - threshold ||
      tableEl.scrollTop + tableEl.clientHeight >=
        tableEl.scrollHeight * percentageThreshold;

    if (isNearBottom) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, 300);

  let dataSource;
  if (isSuccess && isFailed) {
    dataSource = combinedData;
  } else if (isSuccess) {
    dataSource = successData;
  } else if (isFailed) {
    dataSource = errorData;
  } else {
    dataSource = [];
  }

  const paginatedData = dataSource.slice(0, 20 * currentPage);

  return (
    <Modals
      title="Import Report"
      open={openModal}
      setOpen={setOpenModal}
      footer={false}
      width={800}
    >
      <div
        style={{
          padding: "0.5rem",
          fontWeight: "700",
        }}
      >
        <Checkbox
          checked={isSuccess}
          onChange={(e) => setIsSuccess(e.target.checked)}
        >{`${successCount} Success`}</Checkbox>
        <Checkbox
          checked={isFailed}
          onChange={(e) => setIsFailed(e.target.checked)}
        >{`${errorCount} Failed`}</Checkbox>
      </div>
      <div
        onScroll={handleScroll}
        ref={tableRef}
        style={{ maxHeight: "450px", overflowY: "scroll" }}
      >
        <Table
          dataSource={paginatedData}
          bordered
          size="small"
          loading={loading}
          pagination={false}
          rowClassName={(record) =>
            record.isSuccess ? "success_row" : "failed_row"
          }
        >
          <Column
            title="Address"
            key="address"
            render={(record) => record?.address || record?.Address}
          />
          <Column
            title="Code"
            key="code"
            render={(record) => record?.code || record?.Code}
          />
          <Column
            title="Longitude"
            key="longitude"
            render={(record) => record?.longitude || record?.Longitude}
          />
          <Column
            title="Latitude"
            key="latitude"
            render={(record) => record?.latitude || record?.Latitude}
          />

          <Column
            title="Message"
            key="message"
            width="35%"
            render={(record) => record?.message}
          />
        </Table>
      </div>
    </Modals>
  );
};

export default ImportReportSupplier;
